var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#00229A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3984 23.9336C30.1875 24.1445 29.9062 24.25 29.625 24.25C29.3086 24.25 29.0273 24.1445 28.8164 23.9336L25.125 20.2422V31C25.125 31.6328 24.5977 32.125 24 32.125C23.4375 32.125 22.875 31.6328 22.875 31V20.2422L19.1484 23.9336C18.7266 24.3906 17.9883 24.3906 17.5664 23.9336C17.1094 23.5117 17.1094 22.7734 17.5664 22.3516L23.1914 16.7266C23.6133 16.2695 24.3516 16.2695 24.7734 16.7266L30.3984 22.3516C30.8555 22.7734 30.8555 23.5117 30.3984 23.9336Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.abc4c71f3e94c418f8e9c9fd26fca9a4.svg";
export { ForwardRef as ReactComponent };